<div class="chart-container" *ngIf="content != null">
  <div class="utils-row" *ngIf="charts.length > 0">
    <div>
      <mat-checkbox [(ngModel)]="largeSel" (change)="changeLargeSel()">{{ 'stats.graphs.options.largeSel' | translate }}</mat-checkbox>
      <mat-checkbox [(ngModel)]="indexSel" (change)="changeIndexSel()" *ngIf="viewShape != StatsGraphShape.MAP && viewShape != StatsGraphShape.BROWSING">{{ ((viewShape == StatsGraphShape.PIE || viewShape == StatsGraphShape.DONUT) ? 'stats.graphs.options.diagSel' : 'stats.graphs.options.indexSel') | translate }}</mat-checkbox>

      <mat-checkbox [(ngModel)]="stackBar" (change)="changeStackBar()" *ngIf="viewShape == StatsGraphShape.HIST">{{ 'stats.graphs.options.stackBar' | translate }}</mat-checkbox>
    </div>

    <div>
      <ng-container *ngIf="viewShape == StatsGraphShape.BROWSING">
        <button (click)="treeFullLeft()">{{ 'stats.graphs.options.fullLeft' | translate }}</button>
        <button (click)="treeScrollLeft()">{{ 'stats.graphs.options.scrollLeft' | translate }}</button>
        <button (click)="treeScrollRight()">{{ 'stats.graphs.options.scrollRight' | translate }}</button>
        <button (click)="treeFullRight()">{{ 'stats.graphs.options.fullRight' | translate }}</button>
      </ng-container>

      <ng-container *ngIf="viewShape != StatsGraphShape.MAP && viewShape != StatsGraphShape.BROWSING">
        <button (click)="legendShowAll()">{{ 'stats.graphs.options.selectAll' | translate }}</button>
        <button (click)="legendShowNone()">{{ 'stats.graphs.options.unselectAll' | translate }}</button>
      </ng-container>
    </div>
  </div>
  <div class="utils-row" *ngIf="charts.length == 0">
    <div>
    </div>
    <div>
      <ng-container *ngIf="viewShape == StatsGraphShape.TABLE || viewShape == StatsGraphShape.ACTIONS || viewShape == StatsGraphShape.ARBITRARYTABLE">
        <button (click)="exportXlsx()">{{ 'stats.graphs.options.exportXlsx' | translate }}</button>
      </ng-container>
    </div>
  </div>

    <ng-container *ngIf="tableDataSource == null">
      <div class="chart-elem">
        <div class="chart-legend" #legendContainer legend-stats (sizeChange)="setLegendHeight()">
          <div *ngFor="let item of legendItemsS" (click)="legendClick(item)" #legendItemID>
            <span [style.background]=item.fillStyle [style.borderColor]=strokeStyle style.borderWidth="{{item.lineWidth + 'px'}}">
            </span>
            <p [style.color]="item.fontColor" style.textDecoration="{{item.hidden ? 'line-through' : ''}}">
              {{item.text}}
            </p>
          </div>
        </div>
      </div>
      <div class="chart-elem canvas-container {{(canvasTbl.length > 1) ? 'canvas-sizelimiter' : ''}}">
        <div class="{{(canvasTbl.length > 1) ? ((canvasTbl.length > 2) ? 'multismallcanvas' : 'multibigcanvas') : 'singlecanvas'}}" *ngFor="let i of canvasTbl">
          <canvas #canvas>{{ charts[i] }}</canvas>
        </div>
      </div>
    </ng-container>

    <div class="chart-elem">
      <ng-container *ngIf="viewShape != StatsGraphShape.ARBITRARYTABLE">
        <table mat-table [dataSource]="tableDataSource" *ngIf="tableDataSource != null">
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>{{ content.config.xName | translate }}</th>
            <td mat-cell *matCellDef="let element"> {{element.date}} </td>
          </ng-container>

          <ng-container matColumnDef="key">
            <th mat-header-cell *matHeaderCellDef>{{ content.config.keyName | translate }}</th>
            <td mat-cell *matCellDef="let element"> {{element.key | translate }} </td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>{{ content.config.labelName | translate }}</th>
            <td mat-cell *matCellDef="let element"> {{element.name | translate }} </td>
          </ng-container>

          <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef>{{ content.config.yName | translate }}</th>
            <td mat-cell *matCellDef="let element"> {{element.value}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[5, 10]"
                       showFirstLastButtons
                       [hidden]="(tableDataSource == null)">
        </mat-paginator>
      </ng-container>
      <ng-container *ngIf="viewShape == StatsGraphShape.ARBITRARYTABLE">
        <div class="table-wrapper-scroll-y table-sizelimiter">
          <table mat-table class="{{((tableDataSource.data.length > 2000) ? 'table-fixed' : '')}}" [dataSource]="tableDataSource" matSort (matSortChange)="sortTable($event,'1')" *ngIf="tableDataSource != null">
            <ng-container *ngFor="let col of displayedArbDict | keyvalue">
              <ng-container matColumnDef="{{col.key}}">
                <th class="table-cell" mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="!content.config.arbSort">{{ col.value | translate }}</th>
                <td class="table-cell" mat-cell *matCellDef="let element"> {{(element[col.key] == null) ? '' : (Utils.isDate(element[col.key]) ? initDate(element[col.key]).toLocaleString() : (isTranslateKey(element[col.key]) ? (element[col.key] | translate) : element[col.key]))}} </td>
              </ng-container>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="Object.keys(displayedArbDict); sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: Object.keys(displayedArbDict);"></tr>
          </table>
        </div>
      </ng-container>
    </div>
  </div>
<div class="chart-container" *ngIf="loading">
  <span class="chart-elem loading">
    {{ 'stats.common.loading' | translate }}
  </span>
</div>
